<template>
    <b-modal id="bv-modal-logged-off"
            @hide="onHide"
             :hide-footer="true"
             :no-close-on-esc="true"
             :no-close-on-backdrop="true"
             :hide-header-close="true"
    >
        <template v-slot:modal-title>
            {{title}}
        </template>


        <div class="d-block pb-3">
            {{message}}<br/>
        </div>

      <div class="d-block text-center pb-3 pt-4">
        <b-progress  v-if="!buttonEnabled" :value="100" :max="100" animated ></b-progress>
        <b-button v-if="buttonEnabled"  size="md" class="my-2 my-sm-0" variant="plm-tertiary" @click="reload()" >
          <b-icon icon="power" aria-hidden="true"></b-icon>{{$tr('SigIn/SignUp',' Sig In/Sign Up')}}</b-button>
      </div>


    </b-modal>

</template>

<script>


    export default {
        name: "LoggedOff",
        async beforeMount() {
        },
        methods: {

            reload(){
              window.location.href="/dashboard";
            },
            async onHide(ev){
                if(this.resolve != null){
                    this.resolve(null);
                    this.resolve = null;
                }
            },
            reset(){
                this.resolve = null;
            },
            enableButton(){
                this.buttonEnabled = true;
            },
            startCountDown(ctr){
              let msg = this.message;
              this.message = msg.replace("${countDown}", ctr);
              let decrement = () => {
                if(ctr > 0){
                  ctr--;
                  this.message = msg.replace("${countDown}", ctr);
                  setTimeout(decrement, 1000);
                }
              };
              setTimeout(decrement, 1000);
            }
        },
        data: () => ({
            title:"title",
            message:"message",
            resolve: null,
            buttonEnabled:false
        })
    }
</script>
